import * as THREE from "three"

class GradientMaterial extends THREE.ShaderMaterial {
  constructor() {
    super({
      blending: THREE.NormalBlending,
      depthTest: true,
      side: THREE.DoubleSide,
      uniforms: {
        color1: {
          value: new THREE.Color("#ff0000")
        },
        color2: {
          value: new THREE.Color("#00ff00")
        }
      },
      vertexShader: `
        varying vec2 vUv;
        float map(float value, float min1, float max1, float min2, float max2) {
          return min2 + (value - min1) * (max2 - min2) / (max1 - min1);
        }
        void main() {
          vUv.x = map(position.x,-0.5,0.5,0.,1.);
          gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
        }
      `,
      fragmentShader: `
        uniform vec3 color1;
        uniform vec3 color2;
        varying vec2 vUv;
        void main() {
          gl_FragColor = vec4(mix(color1*.75, color2*.75, vUv.x), 1.);
        }`
    })
  }
}

export default GradientMaterial
